// removed by extract-text-webpack-plugin
module.exports = {"flexAlign":"_3Jq3yfPakPUGaG4A5-j8TF"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/FlexAlign/style.css
// module id = 265
// module chunks = 101